import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { SecurityService } from '@core/Security/security.service';
import { EventsEmitterService } from '@core/Abstract/emitter.service';
import { LogService } from '@core/Abstract/log.service';
import { VisualsService } from '@core/Abstract/visuals.service';
import { SnotifyService, SnotifyToastConfig, SnotifyPosition } from 'ng-snotify';

@Component({
    selector: 'app-notifications',
    template: `<ng-snotify class="material"></ng-snotify>`
})
export class NotificationsComponent {

    protected snotifySubscription: Subscription;
  
    protected snotifyConfig: SnotifyToastConfig = {
        timeout: 4000,
        titleMaxLength: 50,
        bodyMaxLength: 500,
        position: SnotifyPosition.rightTop
    };
    protected genericVis = {};


    constructor(private securityService: SecurityService,
        private eventsEmitterService: EventsEmitterService,
        private logger: LogService,
        private visualsService: VisualsService,
        protected snotifyService: SnotifyService
        ) {


        this.loadVisuals();
        this.eventsEmitterService.languageChange.subscribe(
            langId => {
                this.loadVisuals();
            }
        );

        //Set snotify global configuration
        this.snotifyService.setDefaults({
            global: {
                newOnTop: false,
                maxAtPosition: 6,
                maxOnScreen: 6
            }
        });

        this.snotifySubscription = LogService.alertCreate.subscribe(
            alertJSON => {
                if (alertJSON.hasOwnProperty('type')) {
                    switch (alertJSON['type']) {
                        case 'error':
                            this.snotifyService.error(alertJSON['body'], this.genericVis[alertJSON['type']], this.snotifyConfig);
                            break;

                        case 'success':
                            this.snotifyService.success(alertJSON['body'], this.genericVis[alertJSON['type']], this.snotifyConfig);
                            break;

                        case 'info':
                            this.snotifyService.info(alertJSON['body'], this.genericVis[alertJSON['type']], this.snotifyConfig);
                            break;
       

                        case 'warning':
                            this.snotifyService.warning(alertJSON['body'], this.genericVis[alertJSON['type']], this.snotifyConfig);
                            break;

                        default:
                            this.snotifyService.error(alertJSON['body'], this.genericVis['error'], this.snotifyConfig);
                    }
                } else {
                    this.snotifyService.error(alertJSON['body'], this.snotifyConfig);
                }
            }
        );


    }

    ngOnInit(): void { }

    protected loadVisuals(): void {
        this.genericVis = this.visualsService.getFromStorageAsJSON('visualsArray') ? this.visualsService.getFromStorageAsJSON('visualsArray')['generic'] : {};
    }

    ngOnDestroy() {
        // Will clear when component is destroyed e.g. route is navigated away from.
        this.snotifySubscription.unsubscribe();
    }

}
